import { DropdownButton, Button } from 'ca-ui';

export class VRAssetPicker extends DropdownButton {
  static defaultOptions = {
    componentName: 'VRAssetPicker',
    icon: 'search-plus',
    assets: [],
    asset: null,
    dropDown: { width: 872, maxHeight: 500 }
  };

  static icons = null;

  constructor (options) {
    super(
      VRAssetPicker.initOptions(
        $.extend({}, VRAssetPicker.defaultOptions, options)
      )
    );

    this.activeItem = null;

    if (options.addApplyAssetButton) {
      this.applyAssetContainer = $('<div class="ca-vr-assetselect_sticky-container"></div>');
      this.dropDown.el.append(this.applyAssetContainer);

      this.applyAssetButton = new Button({
        icon: 'check',
        label: 'Apply'
      });

      this.applyAssetButton.on('click', function () {
        if (this.options.onSelect) {
          this.options.onSelect(this.options.asset);
          this.options.onAssetSwitch(this.options.asset);
          this.close();
        }
      }.bind(this));
      this.applyAssetContainer.append(this.applyAssetButton.el);
    }
    this.searchbox = $(
      '<input class="ca-vr-assetselect_search" type="input" placeholder="Search..." maxlength="100" />'
    );
    this.searchbox.on(
      'input',
      function () {
        this.filterAssets(this.searchbox.val());
      }.bind(this)
    );
    this.dropDown.el.append(this.searchbox);

    this.list = $('<ul></ul>');
    this.dropDown.add(this.list);

    this.options.assets.forEach(
      function (a) {
        const item = this.createAssetItem(a);
        this.list.append(item);
      }.bind(this)
    );

    this.dropDown.el.on(
      'click',
      function (e) {
        if ($(e.target).hasClass('ca-vr-assetselect_item')) {
          this.setActiveAssetItem($(e.target));
        }
      }.bind(this)
    );
  }

  filterAssets (query) {
    if (query === '') this.list.find('li').show();
    else {
      this.list.find('li:not([data-assetkeywords="#' + query + '"])').show();
      this.list.find('li:not([data-assetkeywords*="#' + query + '"])').hide();
    }
  }

  onOpen () {
    this.searchbox.val('').focus();
  }

  createAssetItem (asset) {
    let keywords = '#' + asset.id + ' #' + asset.name + ' #';
    if (asset.keywords != null) {
      keywords += asset.keywords.split(',').join(' #').replace('# ', '#');
    }

    const item = $(
      '<li class="ca-vr-assetselect_item" data-assetid="' +
        asset.id +
        '" data-assetkeywords="' +
        keywords +
        '"></li>'
    );

    const label = $('<label>' + asset.name + '</label>');
    item.append(label);

    if (asset.id === this.options.asset) this.setActiveAssetItem(item);
    if (this.options.onCreateItem) this.options.onCreateItem(item, asset);
    return item;
  }

  setActiveAssetItem (iconItem) {
    if (this.activeItem) {
      this.activeItem.removeClass('active');
    }

    this.activeItem = iconItem;
    this.activeItem.addClass('active');
    this.options.asset = this.activeItem.data('assetid');

    this.button.setIcon(this.options.iconName);
  }

  static initOptions (options) {
    options.button = { label: 'View all', icon: options.icon };
    return options;
  }
}
